import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageContainer, Tag, Typography } from '@guildeducationinc/recess';
import classNames from 'classnames';
import { useLocale } from 'pe-core-frontend';
import styles from './RoleBanner.module.scss';
export const RoleBanner = ({ className }) => {
    const { t } = useLocale();
    return (_jsx("div", { className: classNames(className, styles.container), children: _jsxs(PageContainer, { withoutTopPadding: true, className: 'flex gap-2 items-center', children: [_jsx(Typography, { variant: 'label2', weight: '700', children: t('Viewing as:') }), _jsx(Tag, { appearance: 'quiet', color: 'grey', className: styles.tag, children: t('Approver') })] }) }));
};
